import * as THREE from "three";
import { OBJExporter, STLExporter } from "three-stdlib";

const stlExporter = new STLExporter();
const objExporter = new OBJExporter();

export function exportMesh(mesh: THREE.Object3D, name: string, format: "stl" | "obj") {
  mesh.updateMatrixWorld(true);

  if (format === "stl") {
    const result = stlExporter.parse(mesh, { binary: true }) as unknown as DataView;
    downloadBlob(new Blob([result.buffer as ArrayBuffer], { type: "application/sla" }), `${name}.stl`);
  } else {
    const result = objExporter.parse(mesh);
    downloadBlob(new Blob([result], { type: "text/plain" }), `${name}.obj`);
  }
}

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
